var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12473 7.51307L0.134725 4.35247C-0.0449084 4.16258 -0.0449084 3.85471 0.134725 3.66481L0.785249 2.97715C0.964882 2.78725 1.25616 2.78725 1.43579 2.97715L3.45 5.10626L7.76421 0.545916C7.94384 0.356033 8.23512 0.356033 8.41475 0.545916L9.06527 1.23357C9.24491 1.42346 9.24491 1.73133 9.06527 1.92123L3.77527 7.51309C3.59562 7.70297 3.30436 7.70297 3.12473 7.51307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCheck);
export default __webpack_public_path__ + "static/media/filter--check.df7cce3f9b87c0abdd26d9d829bfeca7.svg";
export { ForwardRef as ReactComponent };